<template>
  <v-row>
    <v-col
      v-if="members"
      cols="3"
    >
      <v-autocomplete
        chips
        clearable
        multiple
        small-chips
        :items="members.filter(m=> (!selectedShift || (getSchedule(m) && getSchedule(m).shift.id===selectedShift)))"
        label="Filter Members"
        item-text="fullName"
        item-value="id"
        :value="selectedMember"
        @input="onMembersChange"
      />
    </v-col>
    <v-col
      v-if="shifts"
      cols="3"
    >
      <v-autocomplete
        :value="selectedShift"
        clearable
        :items="shifts"
        label="Shift"
        item-text="name"
        item-value="id"
        @input="val=>$emit('update:selectedShift',val)"
      />
    </v-col>
    <v-col
      v-if="groups && parentGroups.length"
      cols="3"
    >
      <v-autocomplete
        v-model="selectedParentGroup"
        clearable
        :items="parentGroups"
        :label="parentGroupLabel"
        item-text="name"
        item-value="id"
        @input="onParentGroupChange"
      />
    </v-col>
    <v-col
      v-if="groups"
      cols="3"
    >
      <v-autocomplete
        v-model="localSelectedGroup"
        multiple
        small-chips
        clearable
        :items="leafGroups"
        :label="groupLabel"
        item-text="name"
        item-value="code"
        @blur="$emit('update:selectedGroup', localSelectedGroup)"
      />
    </v-col>
    <v-col v-if="statuses" cols="3">
      <v-select
        :value="selectedStatus"
        small-chips
        clearable
        :items="statuses"
        label="Status"
        @input="val=>$emit('update:selectedStatus',val)"
      />
    </v-col>
    <v-col v-if="categories && categories.length" cols="3">
      <v-autocomplete
        :value="selectedCategory"
        clearable
        multiple
        small-chips
        :items="categories"
        item-text="label"
        item-value="value"
        label="Category"
        filterable
        @input="val=>$emit('update:selectedCategory',val)"
      />
    </v-col>
    <v-col v-if="jobLevels && jobLevels.length" cols="3">
      <v-autocomplete
        :value="selectedJobLevel"
        clearable
        multiple
        small-chips
        :items="jobLevels"
        label="Job Level"
        filterable
        @input="val=>$emit('update:selectedJobLevel',val)"
      />
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import { mapMutations, mapState, mapGetters } from 'vuex'

  export default {
    name: 'MemberSelector',
    props: ['members', 'shifts', 'groups', 'categories', 'selectedMember', 'selectedShift', 'selectedGroup', 'selectedCategory', 'statuses', 'selectedStatus', 'selectedJobLevel'],
    data() {
      return {
        localSelectedGroup: this.selectedGroup || [],
        selectedParentGroup: null,
      }
    },
    watch: {
      selectedGroup: {
        handler(newVal) {
          this.localSelectedGroup = newVal || []
        },
        immediate: true
      }
    },
    computed: {
      ...mapState('records', ['selectedMemberId']),
      ...mapGetters(['groupsFull', 'userGroups', 'groupLabel', 'parentGroupLabel', 'groupLabelPlural', 'parentGroupLabelPlural']),
      hasUserGroups() {
        return !!(this.userGroups && this.userGroups.length)
      },
      visibleGroups() {
        const all = this.groupsFull || []
        if (!this.hasUserGroups) return all
        return all.filter(g => this.userGroups.includes(g.code))
      },
      parentGroups() {
        const all = this.visibleGroups
        return all.filter(g => all.some(x => +x.parentGroupId === +g.id))
      },
      leafGroups() {
        const all = this.visibleGroups
        return all.filter(g => !all.some(x => +x.parentGroupId === +g.id))
      },
      jobLevels() {
        if (!this.members) return []
        const levels = this.members.map(m => m.jobLevel).filter(l => l)
        return [...new Set(levels)].sort()
      }
    },
    methods: {
      ...mapMutations({
        setSelectedMembersId: 'records/setSelectedMembersId',
      }),
      onMembersChange (val) {

        this.setSelectedMembersId(val)
         this.$emit('update:selectedMember', val)
      },
      onParentGroupChange (parentId) {
        if (!parentId) return
        const codes = this.expandGroupCodes(parentId)
        this.localSelectedGroup = codes
        this.$emit('update:selectedGroup', codes)
        this.selectedParentGroup = null
      },
      expandGroupCodes (groupId) {
        const all = this.visibleGroups
        const codes = new Set()
        const walk = (gid) => {
          all.forEach(g => {
            if (+g.parentGroupId === +gid) {
              if (g.code) codes.add(g.code)
              walk(g.id)
            }
          })
        }
        const parent = all.find(g => +g.id === +groupId)
        if (parent && parent.code) codes.add(parent.code)
        walk(groupId)
        return [...codes]
      },
      refresh () {
        this.$apollo.queries.members.refresh()
      },
      getSchedule (member, date = this.startDate) {
        return member.schedules.find(s => (!s.startDate || moment(s.startDate) <= moment(date)) && (!s.endDate || moment(s.endDate) >= moment(date)) && s.weekDay === moment(date).get('d'))
      },
    },
  }

</script>

<style scoped>

</style>
